/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Api_Reference_Base_TitleInputs */

const en_directory_api_reference_base_title = /** @type {(inputs: Directory_Api_Reference_Base_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base URLs`)
};

const zh_directory_api_reference_base_title = /** @type {(inputs: Directory_Api_Reference_Base_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基础地址`)
};

/**
* | output |
* | --- |
* | "Base URLs" |
*
* @param {Directory_Api_Reference_Base_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_api_reference_base_title = /** @type {((inputs?: Directory_Api_Reference_Base_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Api_Reference_Base_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_api_reference_base_title(inputs)
	return zh_directory_api_reference_base_title(inputs)
});
export { directory_api_reference_base_title as "directory.api_reference.base_title" }